/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
import { createStyledComponent } from '../../../../../utils';

export default createStyledComponent('code', ({ theme }) => ({
  backgroundColor: theme.color_gray_20,
  borderRadius: theme.borderRadius_1,
  fontFamily: theme.fontFamily_monospace,
  padding: theme.space_inset_xs,
  wordBreak: 'break-all'
}));



// WEBPACK FOOTER //
// ./src/website/app/demos/utils/components/Code.js